import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material"
import Icn from "../UI/SharieIcn/SharieIcn"
import { Visibility as VisibilityIcon } from "@mui/icons-material"
import { useRef } from "react"
import ViewSkillModal from "../Modals/ViewSkillModal/ViewSkillModal"

const SimilarSkill = ({ skill }) => {
  const viewRef = useRef()

  const isVideo = (skill) => {
    const mimeType = skill?.image?.split(";")[0] // Get the MIME type
    return mimeType?.startsWith("data:video/") // Check if MIME type starts with "data:video/"
  }
  const openViewModal = () => viewRef.current?.childFunction()
  return (
    <Card
      key={skill?.name}
      elevation={6}
      sx={{
        width: "100%", // Ensure the card takes up the full width of the container
        marginBottom: 2, // Space between cards
      }}
    >
      <ViewSkillModal ref={viewRef} skill={skill} />

      <div
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          color: "text.primary",
          background: "rgba(0,0,0,0.5)",
          borderRadius: "50%",
        }}
      >
        <Icn
          tooltip={"View Skill"}
          onClick={openViewModal}
          icon={<VisibilityIcon style={{ color: "#80CBC4" }} />}
        />
      </div>
      {skill?.image &&
        (isVideo(skill) ? (
          <Box
            component='video'
            controls
            sx={{ width: "100%", height: "400px", objectFit: "cover" }}
          >
            <source src={skill?.image} type='video/mp4' />
            Your browser does not support the video tag.
          </Box>
        ) : (
          <CardMedia
            component='img'
            sx={{ width: "100%", height: "400px", objectFit: "cover" }}
            image={skill?.image}
            alt={skill?.name}
          />
        ))}
      <CardContent>
        <Typography variant='h6' sx={{ fontWeight: 600 }}>
          {skill?.name}
        </Typography>
        <Typography variant='body1' color='text.secondary'>
          📍 Location: {skill?.location || "Unknown"}
        </Typography>
        <Typography variant='body1' color='text.secondary'>
          ⏳ Duration: {skill?.duration || "N/A"}
        </Typography>
        <Typography variant='body2' sx={{ mt: 1 }}>
          {skill?.description || "No description available."}
        </Typography>
      </CardContent>
    </Card>
  )
}
export default SimilarSkill
